import { AWS_CLOUD_FRONT_TRAINING_URL } from 'modules/aws/constants/cloud-front/training'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getImageWorkoutUtil
from 'modules/training/models/workout/utils/get-image'

function getImageUrlWorkoutUtil (instance) {
  const image = getImageWorkoutUtil(instance)
  if (!image) {
    return `${AWS_CLOUD_FRONT_TRAINING_URL}/assets/gymaholic.jpg`
  }
  const id = getIdReduxUtil(instance)
  return `${AWS_CLOUD_FRONT_TRAINING_URL}/workouts/${id}/${image}`
}

export default getImageUrlWorkoutUtil
